import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDelegateAccessViewModel } from 'src/app/ViewModel/DelegateAccessModel';
import { CommonService } from '../Common.service';
import { RestApiService } from '../rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class DelegateAccessService {

  
  private insertDelegateAccess = 'DelegateAccess/PostDelegateAccess'; /** */
  private getDelegateAccess = 'DelegateAccess/GetDelegateAccessList'; /** */

  constructor(private restAPIService: RestApiService, private commonService: CommonService,) { }

  public getDelegateAccessList(){
    return this.restAPIService.new_POST(this.getDelegateAccess, { projectId : this.commonService.getProjectId(), memberId : this.commonService.getLoggedInUserId() });
  }

  public addDelegateAccess(delInputModel: IDelegateAccessViewModel): Observable<any> {

    return this.restAPIService.new_POST(this.insertDelegateAccess, delInputModel);
  }

}
